import { compose } from "redux";
import { ChauffeurList } from "../src/chauffeursNew/ChauffeurList";
import withAuthentication from "../src/withAuthentication";
// @ts-ignore
import { CHAUFFEURS_LIST, permissions } from "../src/routes";

export default compose(withAuthentication(permissions[CHAUFFEURS_LIST]))(
  ChauffeurList,
);
